<!--                                                v-on:click.native="goto(publication.url)"-->
<template>
    <section id="publications" style="min-height: 400px;">
        <mdb-container class="py-5">
            <mdb-row>
                <mdb-col md="6">
                    <h6 class="section-header-top">Peer Reviewed</h6>
                    <h2>PUBLICATIONS</h2>
                    <hr class="hr-bold"/>
                </mdb-col>
            </mdb-row>

            <mdb-row class="">
                <mdb-col xl="6" lg="6" md="6" class="mb-lg-0 mb-5 mt-5" v-for="publication in this.$parent.publications"
                         :key="publication.id">
                    <mdb-view hover>
                        <mdb-card class="gradient">
                            <mdb-card-body>
                                <mdb-card-title class="white-text text-uppercase"
                                                style="min-height: 200px; max-height:200px; overflow:hidden; letter-spacing: 0.08em"
                                ><a style="color: white" :href="publication.url">{{publication.title}}</a>
                                </mdb-card-title>
                                <div>
                                    <mdb-card-text
                                            style="min-height: 60px; max-height:60px; overflow:hidden;color: ghostwhite;">
                                        {{publication.authors}}
                                    </mdb-card-text>
                                </div>
                                <div style="position: absolute;bottom: 20px;">
                                    <mdb-card-text style="color: gold;">{{publication.conference}}
                                         <a v-if="publication.data" :href="publication.data"><i
                                           style="color: white; float: right; padding-left: 20px; font-size: 20px; pointer-events: all;"
                                           class="fas fa-database"
                                        ></i></a>
                                         <a v-if="publication.code" :href="publication.code"><i
                                           style="color: white; float: right; padding-left: 20px; font-size: 20px; pointer-events: all;"
                                           class="fas fa-code"
                                        ></i></a>
                                        <a v-if="publication.video" :href="publication.video"><i
                                           style="color: white; float: right; padding-left: 20px; font-size: 20px; pointer-events: all;"
                                           class="fab fa-youtube"
                                        ></i></a>
                                    </mdb-card-text>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-view>
                </mdb-col>
            </mdb-row>
        </mdb-container>
    </section>
</template>

<script>
    import {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        mdbMask,
        mdbView
    } from 'mdbvue';

    export default {
        name: "Publications",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbCardBody, mdbCardTitle, mdbCardText,
            // mdbMask,
            mdbView
        },
        methods: {
            goto: function (url) {
                window.location.href = url;
            }
        }
    }

</script>

<style scoped>
    .gradient {
        background-color: #778899;
        min-height: 350px;
        max-height: 350px;
        /*min-width: 330px;*/
        /*max-width: 330px;*/
    }

    .card-body {
        background: #778899;
    }

</style>
